export const AVATAR_SELECTION_REQUESTED = "avatar_selection_requested";

export function requestAvatarSelection(scene, avatarId, { source = "user", forceReload = false } = {}) {
  scene.emit(AVATAR_SELECTION_REQUESTED, { avatarId, source, forceReload });
}
